import { createFileRoute, Outlet } from "@tanstack/react-router"
import { BackofficeConversationExperiments } from "modules/backoffice/components/experiments"
import { GetBackofficeConversationExperimentsSchema } from "schema"
import { z } from "zod"

const BackofficeConversationExperimentsSearchSchema = GetBackofficeConversationExperimentsSchema

function RouteComponent() {
  const search = Route.useSearch()

  return (
    <>
      <BackofficeConversationExperiments search={search} routeFullPath={Route.fullPath} />
      <Outlet />
    </>
  )
}

export const Route = createFileRoute("/_base/_auth/backoffice/conversationExperiments/list")({
  component: RouteComponent,
  validateSearch: (
    search: Partial<z.input<typeof BackofficeConversationExperimentsSearchSchema>>,
  ) => {
    return BackofficeConversationExperimentsSearchSchema.parse(search)
  },
})
